<header class="header"
        [class.menu-opened]="menuOpened">
  <div class="header__logo">
    <a routerLink="/"
       (click)="closeMenu()"></a>
  </div>

  <div class="header__menu-content">
    <nav>

      <div *ngFor="let item of menu; let i = index"
           [class.opened]="submenusOpened['i-' + i]"
           [class.submenu]="item.child_items?.length > 0"
           class="item {{item.css_class}}">
        <amg-link
          [path]="item.url"
          [text]="item.title">
        </amg-link>
        <ng-container *ngIf="item.child_items?.length > 0">
          <div
            (click)="toggleSubmenu(i)"
            class="btn-toggle-submenu"></div>
          <ul
            class="submenu__container">
            <li *ngFor="let subItem of item.child_items"
                [attr.data-team]="subItem.object === 'team' ? subItem.slug : ''">
              <amg-link [path]="subItem.object !== 'team' ? subItem.url : ('/' + wpCommonData.pages.team + '/' + subItem.slug)">
                <ng-container *ngIf="subItem.object === 'team'">
                  <div class="team-logo team-logo-bg-light"></div>
                  <div class="team-logo team-logo-bg-team"></div>
                  <div class="team-color-bg"></div>
                </ng-container>

                <span [innerHTML]="subItem.title"
                      class="team-color3-txt"></span>
              </amg-link>
            </li>
          </ul>
        </ng-container>
      </div>
    </nav>

    <div class="header__secondary-menu">
      <div class="subscribe"
           *ngIf="wpCommonData.pages.packages">
        <a [routerLink]="'/' + wpCommonData.pages.packages"
           class="btn btn-brand"
           [textContent]="'subscribe' | label"></a>
      </div>
      <div class="search-btn"
           (click)="searchToggle()">
        <div class="search-btn__icon"></div>
        <div class="search-btn__label"
             [textContent]="'search' | label"></div>
      </div>
      <div class="separator"></div>
      <app-login-button class="login-button--desktop"
                        [isLoggedIn]="userState.isLoggedIn"
                        [iconOnly]="true"></app-login-button>
    </div>
  </div>

  <app-login-button class="login-button--mobile"
                    (click)="closeMenu()"
                    [isLoggedIn]="userState.isLoggedIn"
                    [iconOnly]="true"></app-login-button>

  <div (click)="toggleMenu()"
       class="header__menu-mobile-icon">
    <button class="hamburger"
            [class.is-active]="menuOpened">
      <span class="hamburger__line hamburger__line--top"></span>
      <span class="hamburger__line hamburger__line--middle"></span>
      <span class="hamburger__line hamburger__line--bottom"></span>
    </button>
  </div>
</header>


<div class="search-container"
     [class.search-container--opened]="searchOpened">
  <div (click)="searchToggle()"
       class="search-container__close-btn"></div>


  <div class="search-container__content">
    <label class="search-container__label"
           [textContent]="'search' | label"></label>
    <div class="field-container">
      <form [formGroup]="formSearch"
            class="search-container__form"
            (ngSubmit)="submitSearch($event)">
        <div class="free-text-container">
          <button class="free-text-container__btn"
                  type="submit"></button>
          <input #searchInput
                 [placeholder]="'search_placeholder' | label"
                 class="free-text-container__input"
                 formControlName="q"
                 type="text">
          <div (click)="searchClean()"
               *ngIf="formSearch.value?.q"
               class="free-text-container__clean"></div>
        </div>
      </form>
    </div>
  </div>
</div>
